import React, { Component } from 'react';
import agent from '../../../agent'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ACTS from '../../../constants'

const mapStateToProps = state => ({ ...state.find });

const mapDispatchToProps = dispatch => ({
    onFindTab: tab => 
      dispatch({ type: ACTS.FIND_TAB, tab}),
    onFindId: params =>
      dispatch({ type: ACTS.FIND_ID, payload: agent.Auth.findId(params)}),
    onFindPasswd: params =>
      dispatch({ type: ACTS.FIND_PASSWD, payload: agent.Auth.findPasswd(params) })
});

const Alert = window.Alert;

class Find extends Component {    
    constructor(props) {
        super();
        this.state = {
            userNm: '',
            userId: '',
            email: ''
        }

        this.onFindId = () => {            
          const userNm = this.state.userNm.replace(/ /g, '');
          const email = this.state.email.replace(/ /g, '');
          
          if(userNm === ''){
            Alert.info('이름을 입력하세요.');
          }else if(email === ''){
            Alert.info('이메일을 입력하세요.');
          }else if(window.regExpPattern('email').test(email) === false){
            Alert.info('이메일형식이 아닙니다.');
          }else{
            this.props.onFindId({userNm, email});
          }
        }

        this.onFindPasswd = () => {
            const userId = this.state.userId.replace(/ /g, '');
            const email = this.state.email.replace(/ /g, '');            
            
            if(userId === ''){
              Alert.info('아이디를 입력하세요.');
            }else if(window.regExpPattern('email').test(userId) === false){
              Alert.info('이메일형식의 아이디가 아닙니다.');
            }else if(email === ''){
              Alert.info('이메일을 입력하세요.');
            }else if(window.regExpPattern('email').test(email) === false){
              Alert.info('이메일형식이 아닙니다.');
            }else{
              this.props.onFindPasswd({userId, email});
            }

            //console.log(this.state.userId);
            //console.log(this.state.email);            
        }

        this.changePhone = val => {                        
            let phone = val.replace(/ /g, '').replace(/-/g, '');
            if(window.regExpPattern('phone').test(phone)){
                if(phone.length>8){
                  phone = phone.replace(window.regExpPattern('phone'),"$1-$3-$4");
                }else{
                  phone = phone.replace(window.regExpPattern('phone'),"$3-$4");
                }
              }
              this.setState({phone: phone});
        }
        
    };

    componentWillUpdate(nextProps, nextState) {
        if(nextProps.step === 3 && nextProps.complete === false){
            nextProps.onJoinStep(2);
            Alert.info("중복된 아이디가 존재합니다.\n\n아이디를 변경하세요.");
            return;
        }else if(nextProps.step === 3 && nextProps.complete === true){
            nextProps.onLogin("SN", this.userId, this.userPwd);
        }
    }

    render(){
        return (  
            
            <div className="logBox">
                <div className="logLogo" style={{ fontSize: '20px' }}>
                    아이디 · 비밀번호 찾기
                        {
                            window.SERVICE_NM !== "erp" && 
                            <p style={{ clear: 'both', textAlign: 'center' }}>아직 회원이 아니신가요? <Link to="/join" className="link_text pl10">가입하기</Link></p>
                        }
                </div>
                <div className="tabbtn mb10">
                    <ul id="idTab_ul">
                        <li className={"ctrTabLock" + (this.props.tab === 'id' ? ' on' : '')} style={{ width: '50%'}} onClick={ () => this.props.onFindTab('id') }>아이디 찾기</li>
                        <li className={"ctrTabLock" + (this.props.tab === 'passwd' ? ' on' : '')} style={{ width: '50%' }} onClick={ () => this.props.onFindTab('passwd') }>비밀번호 찾기</li>
                    </ul>
                </div>   
                <div id="listHolder">
                {
                    this.props.tab === 'id' &&
                    <div className="tabInSection">
                        <div className="logForm" style={{ padding: '40px 20px' }}>
                            <input type="text" className="logInput" placeholder="이름을 입력하세요." value={ this.state.userNm } onChange={ e => this.setState({userNm: e.target.value}) }/>
                            <input type="text" className="logInput" placeholder="이메일를 입력하세요." value={ this.state.email } onChange={ e => this.setState({email: e.target.value}) }/>
                            <Link className="norBtn" style={{margin: '0 2% 0 0',  width: '49%', display: 'inline-block' , backgroundColor: '#fff', color: '#333', border: '1px solid #ddd', textAlign: 'center' }} to="/login">취소</Link>
                            <button className="logBtn" style={{ width: '49%' , margin: '0', display: 'inline-block' }} onClick={ this.onFindId }>찾기</button>
                        </div>
                    </div>
                }

                {
                    this.props.tab === 'passwd' &&
                    <div className="tabInSection">
                        <div className="logForm" style={{ padding: '40px 20px' }}>
                            <input type="text" className="logInput" placeholder="아이디를 입력하세요." value={ this.state.userId } onChange={ e => this.setState({userId: e.target.value}) }/>
                            <input type="text" className="logInput" placeholder="이메일을 입력하세요. " value={ this.state.email } onChange={ e => this.setState({email: e.target.value}) }/>                            
                            <Link className="norBtn" style={{margin: '0 2% 0 0',  width: '49%', display: 'inline-block' , backgroundColor: '#fff', color: '#333', border: '1px solid #ddd', textAlign: 'center' }} to="/login">취소</Link>
                            <button className="logBtn" style={{ width: '49%' , margin: '0', display: 'inline-block' }} onClick={ this.onFindPasswd }>찾기</button>
                        </div>
                    </div>
                }
                </div>
            </div> 
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Find);


// WEBPACK FOOTER //
// ./src/components/pages/member/find.js